/**
 * Extracts the pending task-join-request id from an invite URL's query
 * string. Task email invite links carry this id so the app can call
 * joinRequestedTask once the user finishes logging in from the task
 * invitation preview screen (TA-10474 — previously dropped on this path,
 * so an already-registered user's TaskUser was never created).
 *
 * Pure function so it can be unit-tested without mounting AuthStack or
 * touching window.location/sessionStorage.
 */
export const getTaskJoinRequestIdFromUrl = (search: string): string =>
  new URLSearchParams(search).get('request_id') ?? '';
